import { dashboardApi } from "../api/DashboardApi";
import { GroupData } from "../components/dashboard/BasicInformation/BasicInformation";


export async function handleSaveDashboardCustomization(dashboardContext: any) {

  const selectedGroups = dashboardContext.draggableGroups.filter(
    (group: GroupData) => group.selected === true
  );
  const enabledGroups = selectedGroups.map((groups: { id: any }) => groups.id);

  await dashboardApi.postData(
    dashboardContext.channel,
    {
      //basic information
      name: dashboardContext.title,
      order_talks: dashboardContext.orderOfTalks,
      header: JSON.stringify({ title: dashboardContext.title }),
      enabled_groups: `[${enabledGroups.toString()}]`,

      config: JSON.stringify({
        //appearence
        colors: {
          colorText: dashboardContext.appearenceTextColor,
          colorPrimary: dashboardContext.appearencePrimaryColor,
          colorSecondary: dashboardContext.appearenceSecondaryColor,
        },
        // newsletter
        newsletter: {
          colorPrimary: dashboardContext.newsletterPrimaryColor,
          colorSecondary: dashboardContext.newsletterSecondaryColor,
          title: dashboardContext.newsletterCall,
          description: dashboardContext.newsletterText,
          showNewsletter: dashboardContext?.newsLetterIsActive,
        },
      }),

      //footer
      footer: JSON.stringify({
        color: dashboardContext.footerColor,
        footerTextColor: dashboardContext.footerTextColor,
        social: {
          facebook: dashboardContext.footerFacebook,
          twitter: dashboardContext.footerTwitter,
          linkedin: dashboardContext.footerLinkedin,
          youtube: dashboardContext.footerYoutube,
          instagram: dashboardContext.footerInstagram,
          spotify: dashboardContext.footerSpotify,
          site: dashboardContext.footerSite,
        },
      }),

      //images
      //appearence
      logo: dashboardContext.appearenceImageFile,

      //description block
      about_image: dashboardContext.descriptionImageFile,
      body: JSON.stringify({
        eventAbout: {
          title: dashboardContext.descriptionTitle,
          description: dashboardContext.descriptionText,
        },
      }),
    },
    dashboardContext.bannersFile
  );
}
